import { useState } from 'react';

import { BookingCalendly } from '@Components/Calendly';
import { LoanPreferencesHelp } from '@Components/Help/LoanPreferencesHelp';
import OfferHelp from '@Components/Help/OfferHelp';

interface BookCallViewProps {
    successNavLink: string;
}

const BookCallView = ({ successNavLink }: BookCallViewProps) => {
    const [showCalendly, setShowCalendly] = useState<boolean>(true);

    const isLoanPreferences = successNavLink.includes('loan-preference');

    return (
        <div className='mx-auto max-w-400'>
            {showCalendly && (
                <BookingCalendly
                    successNavLink={successNavLink}
                    onClose={() => setShowCalendly(false)}
                />
            )}
            {isLoanPreferences ? <LoanPreferencesHelp /> : <OfferHelp />}
        </div>
    );
};

export default BookCallView;
